import { configureStore } from "@reduxjs/toolkit";
import { reducer as formReducer } from "redux-form";

import { abTestReducer } from "Common/abTestUtils/redux";
import { siteConfigSlice } from "Common/Redux/siteConfig";

import { toastMultipleCompanies } from "./api";

export const reducerSlices = {
  form: formReducer,
  abTests: abTestReducer,
  [siteConfigSlice.name]: siteConfigSlice.reducer,
  [toastMultipleCompanies.reducerPath]: toastMultipleCompanies.reducer,
};

export const createStore = (preloadedState) => {
  const store = configureStore({
    reducer: reducerSlices,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(toastMultipleCompanies.middleware),
    preloadedState,
  });

  return store;
};
